<template>
  <loading-container :loading="loading" style="width: 100%;">
  <main class="main">
    <div class="post">
      <div class="title">{{article.title}}</div>
      <div class="info mt-2"><div class="date">{{article.time}}</div>{{'Автор:'}}<div class="author" >{{author}}</div></div>
      <div class="text mt-2" v-html="article.description"></div>
      <!--<div class="image">
        <img v-if="image" :src="image" alt="">
        Картинка\видео
      </div>
      <div class="notice"><div class="img"><img src="../assets/icons/quote.svg" alt=""></div>{{notice}}</div>
      <div class="num-list">{{numlist}}</div>
      <div class="list">{{list}}</div>
      <div class="subtitle mt-3">{{subtitle}}</div>
      <div class="subtext mt-2">{{subtext}}</div>-->
      <div class="info bottom mt-4">
        <img class="hover_btn" src="../assets/icons/views.svg" alt="">
        {{article.views}}
        <svg @click="like()" :class="{'active': active_like}" class="like ml-3 mr-1" width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.4134 1.83508C17.3781 0.712189 15.9575 0.09375 14.413 0.09375C13.2585 0.09375 12.2012 0.45874 11.2704 1.1785C10.8008 1.54181 10.3752 1.9863 10 2.5051C9.62494 1.98645 9.19922 1.54181 8.7294 1.1785C7.79877 0.45874 6.74149 0.09375 5.58701 0.09375C4.04251 0.09375 2.62177 0.712189 1.58646 1.83508C0.563507 2.94485 0 4.46097 0 6.10434C0 7.79578 0.630341 9.34409 1.98364 10.9771C3.19427 12.4378 4.93423 13.9207 6.94916 15.6377C7.63718 16.2241 8.41705 16.8888 9.22684 17.5968C9.44077 17.7842 9.71527 17.8873 10 17.8873C10.2846 17.8873 10.5592 17.7842 10.7729 17.5971C11.5826 16.8889 12.363 16.224 13.0513 15.6373C15.0659 13.9205 16.8059 12.4378 18.0165 10.9769C19.3698 9.34409 20 7.79578 20 6.10419C20 4.46097 19.4365 2.94485 18.4134 1.83508Z" fill="#636974"/>
        </svg>
        {{article.likes_count}}
      </div>

    </div>
  </main>
    </loading-container>
</template>
<script>

  import LoadingContainer from "@/components/loading-container";
export default {
  name: "post",
  components: {LoadingContainer},
  mounted() {
    this.getArticle();
  },
  data: ()=>({
    article: [],
    author: '',
    loading: true,
    active_like: false
  }),
  methods: {
    getArticle() {
      this.loading = true;
      this.$http.post('/get-article', {
        token: localStorage.getItem('token'),
        id: this.$route.params.id
      }).then(({data}) => {
        if (data.article) {
          this.article = data.article;
          this.author = data.article.user.company.name;
          this.$route.meta.title = data.article.title
          this.active_like = data.article.likes.length > 0 ? true: false;
        }
      })
      .catch((error) => {
          console.log(error)
      })
      .finally(()=> {this.loading = false})
    },
    like() {
      this.$http.post('/like-article', {
        token: localStorage.getItem('token'),
        id: this.$route.params.id
      }).then(({data}) => {
        if (data.status) {
          if (data.status === 'like') {
            this.article.likes_count++;
            this.active_like = true;
          }
          if (data.status === 'dislike') {
            this.article.likes_count--;
            this.active_like = false;
          }
        }
      })
      .catch((error) => {
          console.log(error)
      })
    }
  }

}
</script>

<style scoped lang="scss">
.post{
  margin: 0 auto;
  max-width: 700px;
  background: #FFFFFF;
  box-shadow: 0px 0px 3px #E5E5EA;
  border-radius: 4px;
  border: 1px solid #ffffff;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #2D3137;
  padding: 20px;
  box-sizing: border-box;

  .info{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 11px;
    line-height: 13px;
    color: #636974;
    margin-top: 15px;
    &.bottom{
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      .like{
        &:hover{
          cursor: pointer;
          path{
            fill: #2CB181;
          }
        }
      }
    }
    img{
      margin-right: 6px;
    }
    .date{
      margin-right: 15px;
    }
    .author{
      text-decoration: underline;
      margin-right: 5px;
      color: #2CB181;
      margin-left: 4px;
    }
  }
  .text{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #575A60;
  }
  .image{
    margin-top: 15px;
    margin-bottom: 15px;
    height: 150px;
    width: 100%;
    background: #E0E0E0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notice{
    display: flex;
    align-items: flex-start;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 127.69%;
    color: #2CB181;
    .img{
      margin-right: 15px;
      height: 100%;
    }
  }
  .subtitle{
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 127.69%;
    color: #575A60;
  }
  .subtext{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #575A60;
  }

  .active path {
    fill: #2CB181;
  }
}
</style>
